@if (editPaymentInfoForm) {
  <div class="container">
    <!--Account Info redirect to dashboard page-->
    <div class="acc-info-btn">
      <gds-utility-action
        [data]="{
          icon: {
            iconName: 'left-arrow-v2',
          },
          label: pageLabels?.['address.backCTA'],
          type: 'left-arrow-v2',
          disabled: false,
        }"
        (click)="bacToAccInfo()"
      ></gds-utility-action>
    </div>
    <gds-spacer classes="spacer-70"></gds-spacer>
    <!--Address heading-->
    <gds-heading
      [data]="{
        heading: pageLabels?.['paymentInfo.addCc'],
      }"
      class="A3-W6"
    >
    </gds-heading>
    <!--Address description-->
    <ng-container>
      <gds-spacer classes="spacer-70"></gds-spacer>
      <div [formGroup]="editPaymentInfoForm">
        <gds-credit-card-form
          [data]="{
            formSubheading: {
              heading: pageLabels?.['paymentInfo.cardsAccepted'],
            },
            cardNumber: { primaryLabel: pageLabels?.['paymentInfo.ccNumber'] },
            year: {
              formField: { primaryLabel: pageLabels?.['paymentInfo.ccYear'] },
              placeholder: pageLabels?.['paymentInfo.ccYear'],
              options: yearOptions,
            },
            month: {
              formField: { primaryLabel: pageLabels?.['paymentInfo.ccMonth'] },
              placeholder: pageLabels?.['paymentInfo.ccMonth'],
              options: monthOptions,
            },
            securityCode: {
              primaryLabel: pageLabels?.['paymentInfo.ccSecurityCode'],
              tooltip: pageLabels?.['paymentInfo.securityCodeDescription'],
            },
          }"
          [errors]="{
            cardNumber: errorCardNumber,
            year: errorYear,
            month: errorMonth,
            securityCode: errorSecurityCode,
          }"
          [value]="{
            cardNumber: cardNumber,
            year: selectedYear,
            month: selectedMonth,
            securityCode: securityCode,
          }"
          (creditCardValueChange)="onCreditCardValueChange($event)"
          (creditCardBlurChange)="onCreditCardBlurChange($event)"
          [selectedCreditCardType]="cardType"
        ></gds-credit-card-form>
      </div>
      <gds-spacer classes="spacer-70"></gds-spacer>
      <app-payment-address
        (emitSelectedAddress)="setAddress($event)"
      ></app-payment-address>
      <gds-spacer classes="spacer-70"></gds-spacer>
      <gds-input
        ngDefaultControl
        id="primary"
        class="checkbox-label"
        [data]="{
          primaryLabel: pageLabels?.['paymentInfo.primaryCard'],
          primaryIconTitleText: pageLabels?.['paymentInfo.primaryCard'],
          type: 'checkbox',
          altText: pageLabels?.['editCommPreferences.checkboxAltText'],
          ariaText: pageLabels?.['editCommPreferences.checkboxAltText'],
          required: true,
        }"
        (valueChange)="onPrimaryClick($event)"
        [value]="primaryVal ? 'checked' : ''"
      >
      </gds-input>
      <gds-spacer classes="spacer-70"></gds-spacer>
    </ng-container>
    <gds-sticky-nav-footer
      [data]="{
        button: {
          type: 'primary',
          href: '',
          label: pageLabels?.['trpAdd.confirm'],
          disabled: enableSave && selectedAddress ? 'false' : 'true',
          target: '',
        },
      }"
      (buttonClicked)="onSave()"
    >
    </gds-sticky-nav-footer>
    <gds-spacer classes="spacer-70"></gds-spacer>
  </div>
}
